import * as R from "ramda";

export const byOrdernumber = R.comparator(
  (a: any, b: any) => a.orderNumber < b.orderNumber
);
